module.exports = __webpack_public_path__ + "static/img/brees-2012-img-in-copy.84ca8ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-img-in-copy.jpg
// module id = 2rzi
// module chunks = 1